import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./context/CartContext";
import { CompareProvider } from "./context/CompareContext";
import { ShopifyProductsProvider } from "./context/ShopifyProductsContext";
import { WishlistProvider } from "./context/WishlistContext";
import CartDrawer from "./components/feature/CartDrawer";
import WishlistDrawer from "./components/feature/WishlistDrawer";
import CookieConsentBanner from "./components/feature/CookieConsentBanner";
import AnnouncementBar from "./components/feature/AnnouncementBar";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ShopifyProductsProvider>
          <WishlistProvider>
            <CartProvider>
              <CompareProvider>
                <AnnouncementBar />
                <AppRoutes />
                <CartDrawer />
                <WishlistDrawer />
                <CookieConsentBanner />
              </CompareProvider>
            </CartProvider>
          </WishlistProvider>
        </ShopifyProductsProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
